<template>
  <div class="flex-col">
    <div class="text-wrapper_1 flex-col">
      <span class="text_7">智造更多价值！</span>
      <span class="text_8">服务师生群体,共筑美好校园~</span>
    </div>
    <div class="grid_1 flex-row">
      <div
          class="text-wrapper_2 flex-col"
          v-for="(item, index) in data"
          :key="index"
          @click="handleClick(item.index)"
      >
        <span class="text_9" v-html="item.lanhutext0"></span>
        <span class="text_10" v-html="item.lanhutext1"></span>
        <div class="new-box_1"></div>
        <img class="bg_image" referrerpolicy="no-referrer" :src="item.lanhuBg0" />
      </div>
    </div>
    <span class="text_11">1</span>
    <img
        class="image_2"
        referrerpolicy="no-referrer"
        src="../assets/img/f91844d37c177261e3357a4ff143b95a.webp"
    />
  </div>
</template>
<script>
  export default {
    props: {
      data: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        constants: {}
      };
    },
    emits: ['select'],
    methods: {
      handleClick(value) {
        this.$emit('select', value);
      }
    }
  };
</script>
<style scoped lang="css" src="../assets/index.css" />
